import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './ETPOS/CommonStyles.css';
import AddSell from './ETPOS/AddSell';
import AddDraft from './ETPOS/AddDraft';
import AddQuotation from './ETPOS/AddQuotation';
import AddSalesOrder from './ETPOS/AddSalesOrder';
import SalesOrderList from './ETPOS/SalesOrderList';
import AllSell from './ETPOS/AllSell';

const getInitialViewTab = (propTab, pathname) => {
  if (propTab && propTab !== 'sell') {
    if (propTab === 'list_pos' || propTab === 'pos-list') return 'list_pos';
    if (propTab === 'sales_returns' || propTab === 'sell_return' || propTab === 'sales-returns') return 'sales_returns';
    if (propTab === 'shipment' || propTab === 'shipments') return 'shipment';
    if (propTab === 'discount') return 'discount';
    if (propTab === 'list_quotation') return 'list_quotation';
    if (propTab === 'list_draft') return 'list_draft';
    if (propTab === 'sales_order' || propTab === 'sales-order') return 'sales_order';
    if (propTab === 'pos_sales' || propTab === 'all_sales') return 'all_sales';
  }
  if (pathname === '/sell/pos-list' || pathname === '/sell/pos') return 'list_pos';
  if (pathname === '/sell/sales-returns' || pathname === '/sell-return' || pathname === '/sell/sales_returns') return 'sales_returns';
  if (pathname === '/sell/shipment' || pathname === '/sell/shipments') return 'shipment';
  if (pathname === '/sell/discount' || pathname === '/sell/discounts') return 'discount';
  if (pathname === '/sell/quotation-list' || pathname === '/sell/quotations') return 'list_quotation';
  if (pathname === '/sell/draft-list' || pathname === '/sell/drafts') return 'list_draft';
  if (pathname === '/sell/sales-order' || pathname === '/sell/sales-orders') return 'sales_order';
  return 'all_sales';
};

const getInitialTab = (propTab, pathname) => {
  if (propTab && propTab !== 'sell') {
    if (propTab === 'sell/add-sales-order' || propTab === 'add_sales_order') return 'add_sales_order';
    if (propTab === 'sell/add' || propTab === 'add_sale') return 'add';
    if (propTab === 'sell/add-draft' || propTab === 'add_draft') return 'add_draft';
    if (propTab === 'sell/add-quotation' || propTab === 'add_quotation') return 'add_quotation';
    if ((propTab === 'sales_order' || propTab === 'sales-order') && (pathname === '/sell/add-sales-order' || (pathname === '/sell/add' && window.location.search.includes('sale_type=sales_order')))) {
      return 'add_sales_order';
    }
    return 'view';
  }
  if (pathname === '/sell/create?sale_type=sales_order' || pathname === '/sell/add-sales-order') return 'add_sales_order';
  if (pathname === '/sell/add') return 'add';
  if (pathname === '/sell/add-draft') return 'add_draft';
  if (pathname === '/sell/add-quotation') return 'add_quotation';
  return 'view';
};

const Sell = ({ activeTab: propActiveTab }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(() => getInitialTab(propActiveTab, window.location.pathname));
  const [activeViewTab, setActiveViewTab] = useState(() => getInitialViewTab(propActiveTab, window.location.pathname));
  const [searchTerm, setSearchTerm] = useState('');

  // Synchronize state with prop changes and pathname
  useEffect(() => {
    // If the prop specifies a specific sub-tab, prioritize it
    if (propActiveTab && propActiveTab !== 'sell') {
      if (propActiveTab === 'pos_sales' || propActiveTab === 'all_sales') {
        setActiveTab('view');
        setActiveViewTab('all_sales');
      } else if (propActiveTab === 'list_pos' || propActiveTab === 'pos-list') {
        setActiveTab('view');
        setActiveViewTab('list_pos');
      } else if (propActiveTab === 'sales_returns' || propActiveTab === 'sell_return' || propActiveTab === 'sales-returns') {
        setActiveTab('view');
        setActiveViewTab('sales_returns');
      } else if (propActiveTab === 'shipment' || propActiveTab === 'shipments') {
        setActiveTab('view');
        setActiveViewTab('shipment');
      } else if (propActiveTab === 'discount') {
        setActiveTab('view');
        setActiveViewTab('discount');
      } else if (propActiveTab === 'list_quotation') {
        setActiveTab('view');
        setActiveViewTab('list_quotation');
      } else if (propActiveTab === 'list_draft') {
        setActiveTab('view');
        setActiveViewTab('list_draft');
      } else if (propActiveTab === 'sales_order' || propActiveTab === 'sales-order') {
        if (location.pathname === '/sell/add-sales-order' || 
            (location.pathname === '/sell/add' && (location.state?.sale_type === 'sales_order' || location.search.includes('sale_type=sales_order')))) {
          setActiveTab('add_sales_order');
        } else {
          setActiveTab('view');
          setActiveViewTab('sales_order');
        }
      } else if (propActiveTab === 'sell/add-sales-order' || propActiveTab === 'add_sales_order') {
        setActiveTab('add_sales_order');
      } else if (propActiveTab === 'sell/add' || propActiveTab === 'add_sale') {
        if (location.state?.sale_type === 'sales_order' || location.search.includes('sale_type=sales_order')) {
          setActiveTab('add_sales_order');
        } else {
          setActiveTab('add');
        }
      } else if (propActiveTab === 'sell/add-draft' || propActiveTab === 'add_draft') {
        setActiveTab('add_draft');
      } else if (propActiveTab === 'sell/add-quotation' || propActiveTab === 'add_quotation') {
        setActiveTab('add_quotation');
      }
    } else {
      // Otherwise fall back to location.pathname parsing
      if (location.pathname === '/sell/add') {
        if (location.state?.sale_type === 'sales_order' || location.search.includes('sale_type=sales_order')) {
          setActiveTab('add_sales_order');
        } else {
          setActiveTab('add');
        }
      } else if (location.pathname === '/sell/add-sales-order') {
        setActiveTab('add_sales_order');
      } else if (location.pathname === '/sell/add-draft') {
        setActiveTab('add_draft');
      } else if (location.pathname === '/sell/add-quotation') {
        setActiveTab('add_quotation');
      } else if (location.pathname === '/sell/pos-list' || location.pathname === '/sell/pos') {
        setActiveTab('view');
        setActiveViewTab('list_pos');
      } else if (location.pathname === '/sell/sales-returns' || location.pathname === '/sell-return' || location.pathname === '/sell/sales_returns') {
        setActiveTab('view');
        setActiveViewTab('sales_returns');
      } else if (location.pathname === '/sell/shipment' || location.pathname === '/sell/shipments') {
        setActiveTab('view');
        setActiveViewTab('shipment');
      } else if (location.pathname === '/sell/discount' || location.pathname === '/sell/discounts') {
        setActiveTab('view');
        setActiveViewTab('discount');
      } else if (location.pathname === '/sell/quotation-list' || location.pathname === '/sell/quotations') {
        setActiveTab('view');
        setActiveViewTab('list_quotation');
      } else if (location.pathname === '/sell/draft-list' || location.pathname === '/sell/drafts') {
        setActiveTab('view');
        setActiveViewTab('list_draft');
      } else if (location.pathname === '/sell/sales-order' || location.pathname === '/sell/sales-orders') {
        setActiveTab('view');
        setActiveViewTab('sales_order');
      } else if (location.pathname === '/sell/all' || location.pathname === '/sell') {
        setActiveTab('view');
        setActiveViewTab('all_sales');
      }
    }
  }, [propActiveTab, location.pathname, location.state, location.search]);

  // Render content based on active tab
  const renderContent = () => {
    if (activeTab === 'add_sales_order') {
      return <AddSalesOrder />;
    } else if (activeTab === 'add') {
      return <AddSell />;
    } else if (activeTab === 'add_draft') {
      return <AddDraft />;
    } else if (activeTab === 'add_quotation') {
      return <AddQuotation />;
    } else if (activeViewTab === 'sales_order') {
      return <SalesOrderList searchTerm={searchTerm} />;
    } else {
      return <AllSell searchTerm={searchTerm} initialTab={activeViewTab} />;
    }
  };

  return (
    <div className="module-container">
      <div className="module-content1">
        {renderContent()}
      </div>
    </div>
  );
};

export default Sell;
